import React from 'react';
import './StepProgress.css';

export default function StepProgress(props) {
    const { stepName, progressState } = props;

    return (
        <div className={`step ${progressState === 'Started' ? 'active' : ''} ${(progressState === undefined || progressState === 'Queued') ? 'disabled' : ''}`}>
            {(progressState == undefined || progressState == 'Queued') && <i className="pause circle large icon"/>}
            {progressState == 'Started' && <i className="notched circle loading large icon"/>}
            {progressState == 'Completed' && <i className="green check circle large icon"/>}
            <div className="content">
                <div className="description">{stepName}</div>
            </div>
        </div>
    );
}